import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles } from "lucide-react";

export default function ModuleLocked({ module }) {
  const nav = useNavigate();
  const { t } = useTranslation();
  const name = t(`modules.${module}`);
  return (
    <div className="min-h-[70vh] grid place-items-center" data-testid="module-locked">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-full bg-primary/15 grid place-items-center mx-auto mb-6">
          <Lock className="w-7 h-7 text-primary" />
        </div>
        <div className="label-tiny text-primary mb-2">{t("locked.upgradeRequired")}</div>
        <h1 className="text-3xl font-extrabold mb-3">{name}</h1>
        <p className="text-muted-foreground mb-8">{t("locked.message", { name })}</p>
        <Button onClick={() => nav("/billing")} data-testid="locked-upgrade-btn">
          <Sparkles className="w-4 h-4 mr-2" /> {t("locked.viewPlans")}
        </Button>
      </div>
    </div>
  );
}
